import { render, staticRenderFns } from "./ButtonLoading.vue?vue&type=template&id=772cd264&scoped=true&"
import script from "./ButtonLoading.vue?vue&type=script&lang=js&"
export * from "./ButtonLoading.vue?vue&type=script&lang=js&"
import style0 from "./ButtonLoading.vue?vue&type=style&index=0&id=772cd264&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "772cd264",
  null
  
)

export default component.exports